//Import the json file for each language//
import en from "./en.json";
import es from "./es.json";
import cr from "./cr.json";
import ru from "./ru.json";
import zh from "./zh.json";
import bn from "./bn.json";
import yi from "./yi.json";
import ar from "./ar.json";
import ur from "./ur.json";
import pl from "./pl.json";
import fr from "./fr.json";
import it from "./it.json";
import ko from "./ko.json";

export const defaultLocale = "en";

export const rtlLanguages = [
  'ar','yi','ur',
];

export const languages = {
  en: en,
  es: es,
  cr: cr,
  ru: ru,
  zh: zh,
  bn: bn,
  yi: yi,
  ar: ar,
  ur: ur,
  pl: pl,
  fr: fr,
  it: it,
  ko: ko,
};
